import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import useDisplay from "../../../hooks/useDisplay";
import LSRgH2HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import LSRgH1HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH1HeadLine";

import { route } from "../../../router/route";
import { fileUrl } from "../../../api/api";
import { formatNumberWithCommas } from "../../../util/formatNumber";

function LectureItemPage({ data }) {
  const navigate = useNavigate();
  const { isMobile, isTablet } = useDisplay();
  const isSmall = isMobile || isTablet;

  return (
    <>
      <Container
        onClick={() => {
          navigate(`${route.lecture_detail}/${data.id}`);
        }}
        isMobile={isMobile}
        isTablet={isTablet}
      >
        <div
          style={{
            borderRadius: 10,
            overflow: "hidden",
            width: "100%",
          }}
        >
          <HoverableImage
            isMobile={isMobile}
            src={
              data.thumbnailServerFileName
                ? `${fileUrl}/${data.thumbnailServerFileName}`
                : ""
            }
            alt="video_lecture"
          />
        </div>
        <ProductTitle
          style={{
            fontSize: isMobile ? 16 : 18,
            lineHeight: isMobile ? "22.4px" : "25.2px",
          }}
        >
          {data.title}
        </ProductTitle>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <LSRgH1HeadLine
            style={{
              fontSize: isMobile ? 12 : 16,
              lineHeight: isMobile ? "14.4px" : "22.4px",
              color: "#6F7480",
            }}
          >
            {data.lectureCategory?.title}
          </LSRgH1HeadLine>

          <div
            style={{
              height: isMobile ? 12 : 16,
              width: 1,
              marginLeft: 14,
              marginRight: 14,
              background: "#6F7480",
            }}
          />

          <img
            style={{
              width: 16,
              height: 16,
              marginRight: 4,
            }}
            src={"/assets/icons/star_3d.png"}
            alt="star_3d"
          />
          <LSRgH1HeadLine
            style={{
              color: "#6F7480",
              fontSize: isMobile ? 12 : 16,
              lineHeight: isMobile ? "14.4px" : "22.4px",
            }}
          >
            {Number(data.reviewScore ?? 0).toFixed(1)} (
            {formatNumberWithCommas(data.reviewCount)})
          </LSRgH1HeadLine>
        </div>
      </Container>
    </>
  );
}

export default LectureItemPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  width: ${({ isMobile, isTablet }) =>
    isMobile ? "46.8%" : isTablet ? "47.6%" : "380px"};
  height: ${({ isMobile }) => (isMobile ? "158px" : "309px")};

  position: relative;
  background: #fff;
  cursor: pointer;
`;

const HoverableImage = styled.img`
  width: 100%;
  height: ${({ isMobile }) => (isMobile ? "100px" : "242px")};
  border-radius: 10px;
  transition: transform 0.3s ease, filter 0.3s ease;

  &:hover {
    transform: scale(1.04); /* 이미지 확대 */
    transition: transform 0.3s ease-in-out; /* 부드러운 애니메이션 */
  }
`;

const ProductTitle = styled(LSRgH2HeadLine)`
  color: #101113;
  margin-top: 16px;
  margin-bottom: 4px;

  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;

  display: -webkit-box;
  -webkit-line-clamp: 1; // 원하는 라인수
  -webkit-box-orient: vertical;
`;
